/**
 * FiltrosPeriodo - Filtros de período para a produção
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { CalendarDays } from 'lucide-react';
import { formatDateShort } from './constantes';

const FiltrosPeriodo = ({
  viewFilter,
  setViewFilter,
  customDateStart,
  setCustomDateStart,
  customDateEnd,
  setCustomDateEnd,
  onApplyCustomFilter,
  filterStartDate,
  filterEndDate
}) => {
  return (
    <Card data-testid="filtros-periodo">
      <CardContent className="py-3">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Tabs value={viewFilter} onValueChange={setViewFilter}>
              <TabsList>
                <TabsTrigger value="semana">Semana</TabsTrigger>
                <TabsTrigger value="mensal">Mensal</TabsTrigger>
                <TabsTrigger value="trimestral">Trimestral</TabsTrigger>
                <TabsTrigger value="personalizado">Personalizado</TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
          
          {viewFilter === 'personalizado' && (
            <div className="flex items-center gap-2">
              <Input 
                type="date" 
                value={customDateStart}
                onChange={(e) => setCustomDateStart(e.target.value)}
                className="w-36"
              />
              <span className="text-gray-500">até</span>
              <Input 
                type="date" 
                value={customDateEnd}
                onChange={(e) => setCustomDateEnd(e.target.value)}
                className="w-36"
              />
              <Button size="sm" onClick={onApplyCustomFilter}>Aplicar</Button>
            </div>
          )}
          
          <div className="text-sm text-gray-500">
            <CalendarDays className="h-4 w-4 inline mr-1" />
            {formatDateShort(filterStartDate)} - {formatDateShort(filterEndDate)}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default FiltrosPeriodo;
